// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FormControl = theme => {
  return {
    MuiFormControl: {}
  };
};

export { FormControl };
